import { Provider } from "react-redux";
import "./App.css";
import { RouterProvider } from "react-router-dom";
import appRouter from "routes";
import store from "redux/store";
import { ThemeProvider, createTheme, responsiveFontSizes } from "@mui/material";
import { jaJP } from "@mui/x-date-pickers";

let theme = createTheme(
  {
    palette: {
      primary: {
        main: "#af9b65",
        light: "#d8c79c",
        dark: "#7d6b44",
        contrastText: "#ffffff",
      },
    },
    typography: {
      fontFamily: "Yu Gothic, sans-serif",
      fontSize: 12,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 700,
      // h1: {
      //   fontSize: "2.5rem",
      //   fontWeight: 700,
      //   lineHeight: 1.2,
      //   letterSpacing: "0.05em",
      // },
      // h2: {
      //   fontSize: "2.25rem",
      //   fontWeight: 700,
      //   lineHeight: 1.2,
      //   letterSpacing: "0.05em",
      // },
      // body1: {
      //   fontSize: "1rem",
      //   fontWeight: 400,
      //   lineHeight: 1.5,
      //   letterSpacing: "0.05em",
      // },
    },
  },
  jaJP
);

const responseTheme = responsiveFontSizes(theme);

function App() {
  return (
    <ThemeProvider theme={responseTheme}>
      <Provider store={store}>
        <RouterProvider router={appRouter} />
      </Provider>
    </ThemeProvider>
  );
}

export default App;
